import { useResolvedLang } from '../../utils/resolveLang';
import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Linkedin } from 'react-feather';

import { routes, CustomRouteObject } from "../../AppRoutes";
import LinkButton from '../shared/LinkButton';
import { TranslateRoutes, SiteLang, isSiteLang, translateTail } from '../shared/TranslateRoutes';

import NavImage from "../../assets/img/flowly-logo.png";
import { enFlag, frFlag, spFlag } from "../../assets/img/countries";

const langMap = new Map();
langMap.set("fr", frFlag);
langMap.set("en", enFlag);
langMap.set("es", spFlag);

const translateRoutes = TranslateRoutes();

const handleClose = () => {
    const closeButton = document.querySelector('.btn-close') as HTMLButtonElement | null;
    if (closeButton) closeButton.click();
};

const NavMenu = (): React.JSX.Element => {
    const homeLang = useResolvedLang();
    const location = useLocation();
    const path = location.pathname;
    const { t, i18n } = useTranslation();
    const [currentLang, setCurrentLang] = React.useState(localStorage.getItem("lang") ?? navigator.language ?? "en");
    const [langIcon, setLangIcon] = React.useState(langMap.get(localStorage.getItem("lang") ?? navigator.language ?? "en"));
    const expand = "lg";
    const langs = Array.from(langMap.keys());
    let loops = 0;
    let mlAuto = '';


    const pathSegments = location.pathname.split('/').filter(Boolean);
    const pathLang = pathSegments[0];

    const [manageUrl, setManageUrl] = useState<boolean>(true);


    React.useEffect(() => {

        if (['en', 'fr', 'es'].includes(pathLang)) {
            if (pathLang !== currentLang && manageUrl) {
                setCurrentLang(pathLang);
                localStorage.setItem("lang", pathLang);
                setManageUrl(false)
            }
        } else {
            setCurrentLang(localStorage.getItem("lang") === undefined ? navigator.language : localStorage.getItem("lang")!);
        }
    }, [path, currentLang, manageUrl, pathLang]);

    React.useEffect(() => {
        setLangIcon(langMap.get(currentLang));
        i18n.changeLanguage(currentLang);
        localStorage.setItem("lang", currentLang);
        //const currentPath = location.pathname.split('/').slice(2).join('/');
        //navigate(`/${currentLang}/${currentPath}`, { replace: true });
    }, [currentLang, i18n]);

    return (
            <>
            <Navbar expand={expand} className="mb-3 flowly-navbar">
                <Container>

                    <Navbar.Brand as={NavLink} to={`/${homeLang}`} end>
                        <img src={NavImage} alt="Logo de Flowly" />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
                    <Navbar.Offcanvas
                        id={`offcanvasNavbar-expand-${expand}`}
                        aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
                        placement="end"
                    >
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`} className="flowly-logo-offcanvas">
                                <Navbar.Brand as={NavLink} to={`/${homeLang}`} onClick={handleClose} end>
                                    <img className="nav-home" src={NavImage} alt="Logo de Flowly" />
                                </Navbar.Brand>
                            </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <Nav className="justify-content-end flex-grow-1 pe-3 navbar-content">
                                {
                                    routes[1].children !== undefined && routes[1].children.map((el: CustomRouteObject, index: number) => {
                                        mlAuto = '';
                                        if (loops <= 0) mlAuto = "d-none";
                                        if (loops === 1) mlAuto = "nav-ml-auto";
                                        ++loops;
                                        if (el.visible !== undefined && !el.visible) return '';
                                        let elTitle = el.title === undefined ? "" : t(el.title);
                                        let tempPath = "";
                                        if (el.path !== undefined) tempPath = el.path;
                                        if (el.children === undefined)
                                            return (<Nav.Link className={`default-nav-padding ${mlAuto}`} key={index} as={NavLink} eventKey={tempPath} to={tempPath} onClick={handleClose} active={el.path === undefined ? false : path.startsWith(el.path)} end>
                                                {elTitle}
                                                </Nav.Link>)
                                        else
                                            return (<NavDropdown className={`default-nav-padding ${mlAuto}`} key={index} title={elTitle} id="basic-nav-dropdown" onClick={handleClose} active={el.path === undefined ? false : path.startsWith(el.path)}>
                                                {
                                                    el.children.map((child, indexChild) => {
                                                        elTitle = child.title === undefined ? "" : t(child.title);
                                                        if (child.path !== undefined) tempPath = `${el.path}/${child.path}`;
                                                        return <NavDropdown.Item key={indexChild} className='text-style' as={NavLink} eventKey={tempPath} to={tempPath} onClick={child.close ? handleClose : undefined}>{elTitle}</NavDropdown.Item>
                                                    })
                                                }
                                                </NavDropdown>)
                                    })
                                }

                                <LinkButton to={`/${translateRoutes.contact}/?link=demo`} className="flowly-btn red nav-demo">{t('NavBar.Demo')}</LinkButton>
                                <div className="navbar-flowly-icon">
                                    <div className="lk-container">
                                        <a href="https://www.linkedin.com/company/flowly1/" target="_blank" rel="noreferrer" className="navlink-outside"><Linkedin size="18" /></a>
                                        <p dangerouslySetInnerHTML={
                                            { __html: t('NavBar.FollowFlowly') === undefined ? "" : t('NavBar.FollowFlowly') }
                                        } />
                                    </div>
                                    <LinkButton to={`/${translateRoutes.contact}/?link=demo`} className="flowly-btn red out-demo">{t('NavBar.Demo')}</LinkButton>
                                    <NavDropdown className="navbar-language" title={<div className='lc-text'><img className="flowly-country-flag round-border d-none" src={langIcon} alt={t(`Langue.tag`)} /> {t(`Langue.tag`)}</div>}>
                                        { 
                                            langs.map((lang, index)=>
                                                <NavDropdown.Item id={lang} eventKey={lang} key={index} onClick={(e) => {
                                                    // On reste sur la page courante, dont le chemin est traduit dans la langue choisie.
                                                    const target = e.currentTarget.id as SiteLang;
                                                    const from = (isSiteLang(pathLang) ? pathLang : currentLang) as SiteLang;
                                                    const tail = translateTail(pathSegments.slice(isSiteLang(pathLang) ? 1 : 0), from, target);
                                                    localStorage.setItem("lang", target);
                                                    window.location.replace(`/${[target, ...tail].join('/')}${location.search}${location.hash}`);
                                            }}>
                                                    <img className="flowly-country-flag round-border d-none" src={langMap.get(lang)} alt={t(`Langue.${lang}`)} /> <span style={{marginLeft: "10px"}}>{t(`Langue.${lang}`)}</span>
                                            </NavDropdown.Item>)
                                        }
                                    </NavDropdown>
                                </div>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Container>
            </Navbar>
    </>
    );
};

export default NavMenu;
